
import FilterOptionItem from "./FilterOptionItem.vue";
import { getIdFromSlug } from "../../utils/common";
import { isMobile } from "../../utils/common";
export default {
  components: { FilterOptionItem },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      mobile: false,
      userName: "",
      major_name: "",
      metadata: {
        current_page: 1,
        page_size: 10,
        total_items: 0,
        total_page: 1,
      },
      // dataSource: [
      //     {
      //         key: "1",
      //         specialty: {
      //             name: "Ngành Toán tin - Cao cấp",
      //             code: "799006AR"
      //         },
      //         subject: "A00,A01,B00,D01,D07",
      //         grade: 274,
      //         standard: 492,
      //         tuition: 406.27
      //     },
      dataSource: [],

      columns: [
        {
          title: "Mã ngành",
          width: 131,
          align: "left",
          dataIndex: "majors_id",
          key: "majors_id",
        },
        {
          title: "Tên ngành",
          dataIndex: "major_name",
          key: "major_name",
          width: 749,
          // scopedSlots: { customRender: "majors" },
        },

        {
          title: "Tổ hợp xét tuyển",
          dataIndex: "combination_subjects",
          key: "combination_subjects",
          width: 200,
          // scopedSlots: { customRender: "subject" },
        },
        {
          title: "Điểm chuẩn",
          dataIndex: "benchmark",
          key: "benchmark",
          width: 120,
          align: "left",
        },
      ],
    };
  },
  computed: {
    getLoading() {
      const loading = this.$store.state.Major.majorLoading;
      return loading;
    },
  },
  mounted() {
    this.mobile = isMobile();
    this.getMajors();
  },
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`);
    },
    async getMajors() {
      const { id } = this.$route.params;
      const result = await this.$store.dispatch(
        "Major/getListGroupMajorBySchoolId",
        {
          school_id: getIdFromSlug(id),
          page: this.metadata.current_page,
          ...(this.major_name.length > 0 && { major_name: this.major_name }),
        }
      );

      if (result.code === 200) {
        if (Array.isArray(result.data) && result.data.length > 0) {
          let dataMaping = [];
          result.data.forEach((item, index) => {
            // const subjectsMapping = String(item.combination_subject).replaceAll(
            //   /\s\s+/g,
            //   "\n"
            // );
            dataMaping.push({
              ...item,
              key: item.id,
            });
          });
          this.dataSource = dataMaping;
          this.metadata = result.metadata;
        } else {
          this.dataSource = [];
          this.metadata = result.metadata;
        }
      }
    },
    async handleSearch() {
      await this.getMajors();
      this.major_name = "";
    },
  },
};
